<template>
  <MenuLink :menus="['プロフィール', 'ユーザ復元', 'JWT']" />
</template>

<script>
import MenuLink from "src/components/shared/menu/MenuLink";

export default {
  name: "Develop",
  components: { MenuLink },
};
</script>
